export default "__VITE_ASSET__DYzqmkMP__"